module.exports = __webpack_public_path__ + "static/media/hippo.e49eec55.svg";